<!-- 牛人推荐 -->
<template>
  <div class="recom">
    <!-- 导航栏 -->
    <van-nav-bar title="牛人推荐" fixed placeholder z-index="10"></van-nav-bar>
    <!-- 切换 -->

    <!-- 筛选 企业 -->
    <!-- <van-tabs
      v-model="active"
      sticky
      title-active-color="#ff4343"
      swipeable
      :ellipsis="false"
      animated
      @click="tabs"
    >
      <van-tab
        v-for="(item,index) in tabList"
        :title="item.name"
        :key="index"
        :name="item.category_id"
      >
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            :immediate-check="false"
          >
            <div class="status-all" v-for="(item, index) in list" :key="index">
              <div class="user-box" @click="goResume(item.resume_id)">
                <div>
                  <div class="user-name">{{item.name}}</div>
                  <div class="user-position">
                    <span v-if="item.soldier_type_name!=''">{{item.soldier_type_name}}</span>
                    <span v-if="item.soldier_type_name!=''">{{item.education_name}}</span>
                    <span>{{arr[index]+1}}岁</span>
                  </div>
                  <div class="user-icon">
                    <span>{{item.job_intent}}</span>
                    <span>{{item.job_wage}}</span>
                  </div>
                </div>
                <img :src="item.avatar" class="head-img" />
              </div>
              <div class="user-description">
                <div class="user-text">{{item.description==null?'还没有添加个人简介~':item.description}}</div>
                <van-icon
                  :name="item.is_collect?'star':'star-o'"
                  size="30"
                  color="#FF6F00"
                  @click="collect([item.resume_id,item.is_collect])"
                />
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>-->
    <!-- 列表 -->
    <div class="recom-title">
      <div class="item-left">
        <span :class="check?'selected':''" @click="recommend(1)">推荐</span>
        <span :class="!check?'selected':''" @click="recommend(2)">最新</span>
      </div>
      <!-- <router-link to="/home/screen">
        <div class="item-right">
          <span>筛选</span>
          <img src="@/assets/img/home/selectDown.png" />
        </div>
      </router-link>-->
    </div>
    <!-- 列表 -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
        :immediate-check="false"
      >
        <div class="status-all" v-for="(item, index) in list" :key="index">
          <div class="user-box" @click="goResume(item.resume_id)">
            <div>
              <div class="user-name">{{item.name}}</div>
              <div class="user-position">
                <span v-if="item.soldier_type_name!=''">{{item.soldier_type_name}}</span>
                <span v-if="item.soldier_type_name!=''">{{item.education_name}}</span>
                <span>{{arr[index]+1}}岁</span>
              </div>
              <div class="user-icon">
                <span>{{item.job_intent}}</span>
                <span>{{item.job_wage}}</span>
              </div>
            </div>
            <img :src="item.avatar" class="head-img" />
          </div>
          <div class="user-description">
            <div class="user-text">{{item.description==null?'还没有添加个人简介~':item.description}}</div>
            <van-icon
              :name="item.is_collect?'star':'star-o'"
              size="30"
              color="#FF6F00"
              @click="collect([item.resume_id,item.is_collect])"
            />
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import {
  tjList,
  getCompanyDetail,
  getKindArray,
  Resumecollect,
  ResumeCollectCancel
} from "@/api/apiData";
import { Toast } from "vant";
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      active: 0,
      check: true,
      page: 0,
      totalPages: 1,
      list: [],
      offset: 10,
      loading: false,
      finished: false,
      refreshing: false,
      arr: [],
      is_recommend: 1,
      is_latest: "",
      tabList: [], //标签栏
      categoryId: "" //分类id
    };
  },
  computed: {
    ...mapState(["token"])
  },
  methods: {
    // 标签栏切换
    tabs(val) {
      const that = this;
      that.categoryId = val;
      that.totalPages = 1;
      that.page = 0;
      that.list = [];
      that.loading = false;
      that.finished = false;
      that.refreshing = false;
      that.getList();
    },
    //收藏
    collect(val) {
      const that = this;
      let obj = {
        token: that.token,
        resume_id: val[0]
      };
      if (val[1]) {
        ResumeCollectCancel(obj).then(res => {
          // //(res);
          if (res.code == 1) {
            Toast.success({
              message: res.msg,
              forbidClick: true
            });
            that.list.forEach((item, index) => {
              if (item.resume_id == val[0]) {
                that.list[index].is_collect = false;
              }
            });
          } else {
            Toast.fail({
              message: res.msg,
              forbidClick: true
            });
          }
        });
      } else {
        Resumecollect(obj).then(res => {
          // //(res);
          if (res.code == 1) {
            Toast.success({
              message: res.msg,
              forbidClick: true
            });
            that.list.forEach((item, index) => {
              if (item.resume_id == val[0]) {
                that.list[index].is_collect = true;
              }
            });
          } else {
            Toast.fail({
              message: res.msg,
              forbidClick: true
            });
          }
        });
      }
    },
    // 推荐
    recommend(val) {
      const that = this;
      that.check = !that.check;
      if (val == 1) {
        that.is_recommend = 1;
        that.is_latest = "";
      } else {
        that.is_recommend = "";
        that.is_latest = 1;
      }

      that.page = 0;
      that.totalPages = 1;
      that.list = [];
      that.loading = false;
      that.finished = false;
      that.getList();
    },
    // 上拉加载
    onLoad() {
      var that = this;
      that.getList();
    },
    // 下拉刷新
    onRefresh() {
      var that = this;
      that.totalPages = 1;
      that.page = 0;
      that.loading = false;
      that.finished = false;
      that.list = [];
      that.getList();
      setTimeout(() => {
        that.refreshing = false;
      }, 1500);
    },
    //获取推荐列表
    getList() {
      var that = this;
      let {
        page,
        totalPages,
        list,
        offset,
        is_recommend,
        is_latest,
        categoryId
      } = that;
      let obj = {
        page: page + 1,
        offset: offset,
        // trade: categoryId
        is_recommend: is_recommend,
        is_latest: is_latest
        // education:education,
        // experience:experience,
        // min_salary:min_salary,
        // max_salary:max_salary,
        // soldier_type:soldier_type
      };
      that.loading = true;
      if (totalPages > page) {
        tjList(obj).then(res => {
          if (res.code == 1) {
            that.list = list.concat(res.data.list);
            that.page = page + 1;
            that.totalPages = Math.ceil(Number(res.data.total) / offset);
            if (res.data.list.length == 0) {
              setTimeout(() => {
                that.finished = true;
                that.loading = false;
              }, 1500);
              return false;
            }
            if (that.list.length > list.length) {
              that.list.forEach(item => {
                var birthday = item.birthday;
                var index = birthday.indexOf("-");
                var date = birthday.substring(0, index);
                var nowDate = new Date();
                var Y = nowDate.getFullYear();
                var age = Y - Number(date);
                that.arr.push(age);
              });
              setTimeout(() => {
                that.loading = false;
              }, 1500);
            }
          } else {
            Toast(res.msg);
          }
        });
      } else {
        that.finished = true;
        that.loading = false;
      }
    },
    // 查看简历
    goResume(id) {
      var that = this;
      that.$router.push({
        name: "resumeDetails",
        query: {
          id: id,
          type: 0
        }
      });
    }
  },
  created() {},
  mounted() {
    // getKindArray({ key: "trade" }).then(res => {
    //   //(res);
    //   this.tabList = res.data;
    //   this.categoryId = res.data[0].category_id;
    //   this.getList();
    // });
    this.getList();
  }
};
</script>
<style lang='less' scoped>
/deep/.van-tab__text {
  font-size: 0.3rem;
  font-weight: 550;
}
/deep/.van-tabs__nav--line {
  height: 120%;
}
/deep/.van-hairline--bottom {
  border: 0;
}
/deep/[class*="van-hairline"]::after {
  border-top-color: transparent;
}
.recom {
  background: #f7f7f7;
}
.recom-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.24rem 0.4rem;
  border-bottom: 1px solid rgba(178, 178, 178, 0.3);
  background: #fff;
  .item-left {
    font-size: 0.3rem;
    font-weight: 400;
    line-height: 0.42rem;
    color: rgba(128, 128, 128, 1);

    span {
      margin-right: 0.4rem;
    }
    .selected {
      font-weight: bold;
      color: #ff4343;
    }
  }
  .item-right {
    display: flex;
    align-items: center;
    font-size: 0.24rem;
    font-weight: 500;
    line-height: 0.33rem;
    color: rgba(128, 128, 128, 1);
    background: #f7f7f7;
    padding: 0.1rem 0.15rem;
    border-radius: 0.08rem;
    img {
      width: 0.3rem;
      height: 0.3rem;
    }
  }
}
// 全部
.status-all {
  // display: flex;
  // align-items: center;
  padding: 0.36rem 0.32rem;
  margin-bottom: 0.2rem;
  // justify-content: space-between;
  background: #fff;
  .head-img {
    width: 1.18rem;
    height: 1.18rem;
    border-radius: 50%;
    align-self: flex-start;
  }
  .user-box {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .user-name {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 0.36rem;
      font-weight: bold;
      line-height: 0.42rem;
      color: #333;
      // span:last-child {
      //   font-size: 0.26rem;
      //   font-weight: 400;
      //   line-height: 0.37rem;
      //   color: rgba(102, 102, 102, 1);
      // }
    }
    .user-icon {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      font-size: 0.24rem;
      font-weight: 400;
      line-height: 0.33rem;
      color: rgba(128, 128, 128, 1);
      position: relative;
      span {
        padding: 0.02rem 0.04rem;
        border-radius: 0.04rem;
        background: rgba(247, 247, 247, 1);
        font-size: 0.2rem;
        font-weight: 400;
        line-height: 0.28rem;
        color: rgba(128, 128, 128, 1);
        margin: 0.08rem 0.12rem 0.08rem 0;
      }
      //   p {
      //     position: absolute;
      //     right: 0;
      //     font-size: 0.28rem;

      //     font-weight: bold;
      //     line-height: 0.4rem;
      //     color: rgba(51, 51, 51, 1);
      //   }
    }
    .user-position {
      display: flex;
      align-items: center;
      position: relative;
      margin: 0.2rem 0;
      span {
        font-size: 0.24rem;
        font-weight: 400;
        line-height: 0.33rem;
        color: rgba(51, 51, 51, 1);
        display: flex;
        align-items: center;
      }
      span::after {
        content: "";
        display: block;
        height: 0.25rem;
        width: 0.02rem;
        background: rgba(178, 178, 178, 0.8);
        margin: 0 0.2rem;
      }
      span:last-child::after {
        display: none;
      }
      //   p {
      //     position: absolute;
      //     right: 0;
      //     font-size: 0.24rem;
      //     font-weight: 400;
      //     line-height: 0.33rem;
      //     color: rgba(128, 128, 128, 1);
      //   }
    }
  }
  .user-description {
    display: flex;
    justify-content: space-between;
    margin-top: 0.1rem;
    .user-text {
      width: 80%;
      font-size: 0.26rem;
      font-weight: 500;
      line-height: 1.5;
      color: #333333;
    }
    .van-icon {
      display: flex;
      justify-content: flex-end;
    }
    .van-icon::before {
      align-self: flex-end;
      padding-bottom: 0.1rem;
    }
  }
}
</style>